import type { RealityCheckInterval } from '../../../types';

const REALITY_CHECK_INTERVALS = ['PT1H', 'PT2H', 'PT3H', 'PT4H', 'PT5H'] as const satisfies readonly RealityCheckInterval[];

type RealityCheckSheetInterval = (typeof REALITY_CHECK_INTERVALS)[number];

/** Maps API / props to the initial radio selection (`NO_SET` and unknown → default PT1H). */
function getInitialRealityCheckInterval(currentInterval?: string): RealityCheckSheetInterval {
  if (currentInterval && (REALITY_CHECK_INTERVALS as readonly string[]).includes(currentInterval)) {
    return currentInterval as RealityCheckSheetInterval;
  }
  return 'PT1H';
}

export { getInitialRealityCheckInterval, REALITY_CHECK_INTERVALS, type RealityCheckSheetInterval };
